(() => {
    const second = 1000, minute = 60 * second, hour = 60 * minute, day = 24 * hour;

    // Grab the timer element
    const timer = document.querySelector('.timer');
    if (!timer) return;

    // Parse end date (from data-end-iso)
    const endMs = Date.parse(timer.dataset.endIso);
    if (!Number.isFinite(endMs)) {
        timer.style.display = 'none';
        return;
    }

    // Correct for user clock skew using server timestamp
    let skewMs = 0;
    const serverNow = Number(timer.dataset.serverNowEpoch);
    if (Number.isFinite(serverNow)) {
        skewMs = serverNow - Date.now();
    }

    // Elements to update
    const elDays = timer.querySelector('.js-timer-days');
    const elHours = timer.querySelector('.js-timer-hours');
    const elMinutes = timer.querySelector('.js-timer-minutes');
    const elSeconds = timer.querySelector('.js-timer-seconds');

    // Render countdown
    function renderTimer(ms) {
        const d = Math.max(0, ms);
        const days = Math.floor(d / day);
        const hours = Math.floor((d % day) / hour);
        const minutes = Math.floor((d % hour) / minute);
        const seconds = Math.floor((d % minute) / second);

        // Update elements
        if (elDays) elDays.textContent = days;
        if (elHours) elHours.textContent = hours;
        if (elMinutes) elMinutes.textContent = minutes;
        if (elSeconds) elSeconds.textContent = seconds;
    }

    // Main tick loop
    function tick() {
        const now = Date.now() + skewMs;
        const distance = endMs - now;

        // only show timer if within 24 hours of sale end
        if (distance > day || distance <= 0) {
            timer.style.display = 'none';
            return
        }
        timer.style.display = 'flex';
        renderTimer(distance);
        setTimeout(tick, 1000); // rerender timer every second
    }

    tick();
})();
